import { type IAttribute } from '../models/Attributes'

interface TransformedAttribute {
  title: string
  value: string
  attributeType?: string
}

export const transformAttributesListForDropdown = (attributesList: IAttribute[]): TransformedAttribute[] => {
  return attributesList?.map((attribute: { attributeValues: any[], attributeKey: any, attributeType?: string }) =>
    attribute.attributeValues?.map((value) => ({
      title: attribute.attributeKey,
      value,
      attributeType: attribute.attributeType
    }))
  ).flat()
}
